module.exports = __webpack_public_path__ + "static/media/247-haiti.e26b4582.svg";